module.exports = __webpack_public_path__ + "static/media/menu-customer-white.ff7d5946.svg";